import { render } from "./phone_header.vue?vue&type=template&id=d6b8effc&scoped=true"
import script from "./phone_header.vue?vue&type=script&scoped=true&lang=js"
export * from "./phone_header.vue?vue&type=script&scoped=true&lang=js"

import "./phone_header.vue?vue&type=style&index=0&id=d6b8effc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b8effc"]])

export default __exports__